import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadQuillDocumentById: IQuillDocumentLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_QUILLDOCUMENT_LOAD_BY_ID,
            id
        }
    },
    LoadQuillDocumentByTypeAndPage: IQuillDocumentLoadByTypeAndPageActionCreator = (quillDocumentType, page) => {
        return {
            type: ACTION_QUILLDOCUMENT_LOAD_BY_TYPE_AND_PAGE,
            quillDocumentType,
            page
        }
    },
    SearchQuillDocuments: IQuillDocumentsSearchActionCreator = (search) => {
        return {
            type: ACTION_QUILLDOCUMENT_SEARCH,
            search,
        }
    },
    LoadSuccess: IQuillDocumentLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IQuillDocumentLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_LOAD_FAILURE,
            responseStatus
        }
    },

    SearchSuccess: IQuillDocumentsSearchSuccessActionCreator = (searchResult, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_SEARCH_SUCCESS,
            searchResult,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SearchFailure: IQuillDocumentsSearchFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_SEARCH_FAILURE,
            responseStatus
        }
    },

    SaveQuillDocument: IQuillDocumentSaveActionCreator = (formData) => {
        return {
            type: ACTION_QUILLDOCUMENT_SAVE,
            formData
        }
    },
    SaveSuccess: IQuillDocumentSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IQuillDocumentSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateQuillDocument: IQuillDocumentCreateActionCreator = (quillDocumentType, page) => {
        return {
            type: ACTION_QUILLDOCUMENT_CREATE,
            quillDocumentType,
            page
        }
    },
    CreateSuccess: IQuillDocumentCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_QUILLDOCUMENT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IQuillDocumentCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateQuillDocument: IQuillDocumentValidateActionCreator = (formData) => {
        return {
            type: ACTION_QUILLDOCUMENT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IQuillDocumentValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IQuillDocumentValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_QUILLDOCUMENT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IQuillDocumentClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_QUILLDOCUMENT_CLEAR,
            propertiesToClear
        }
    },
    Filter: IQuillDocumentFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_QUILLDOCUMENT_FILTER,
            formFilter
        }
    };

export const
    ACTION_QUILLDOCUMENT_LOAD_BY_ID = "ACTION_QUILLDOCUMENT_LOAD_BY_ID",
    ACTION_QUILLDOCUMENT_LOAD_BY_TYPE_AND_PAGE = "ACTION_QUILLDOCUMENT_LOAD_BY_TYPE_AND_PAGE",
    ACTION_QUILLDOCUMENT_SEARCH = "ACTION_QUILLDOCUMENT_SEARCH",
    ACTION_QUILLDOCUMENT_LOAD_SUCCESS = "ACTION_QUILLDOCUMENT_LOAD_SUCCESS",
    ACTION_QUILLDOCUMENT_LOAD_FAILURE = "ACTION_QUILLDOCUMENT_LOAD_FAILURE",
    ACTION_QUILLDOCUMENT_SEARCH_SUCCESS = "ACTION_QUILLDOCUMENT_SEARCH_SUCCESS",
    ACTION_QUILLDOCUMENT_SEARCH_FAILURE = "ACTION_QUILLDOCUMENT_SEARCH_FAILURE",

    ACTION_QUILLDOCUMENT_SAVE = "ACTION_QUILLDOCUMENT_SAVE",
    ACTION_QUILLDOCUMENT_SAVE_SUCCESS = "ACTION_QUILLDOCUMENT_SAVE_SUCCESS",
    ACTION_QUILLDOCUMENT_SAVE_FAILURE = "ACTION_QUILLDOCUMENT_SAVE_FAILURE",

    ACTION_QUILLDOCUMENT_CREATE = "ACTION_QUILLDOCUMENT_CREATE",
    ACTION_QUILLDOCUMENT_CREATE_SUCCESS = "ACTION_QUILLDOCUMENT_CREATE_SUCCESS",
    ACTION_QUILLDOCUMENT_CREATE_FAILURE = "ACTION_QUILLDOCUMENT_CREATE_FAILURE",

    ACTION_QUILLDOCUMENT_VALIDATE = "ACTION_QUILLDOCUMENT_VALIDATE",
    ACTION_QUILLDOCUMENT_VALIDATE_SUCCESS = "ACTION_QUILLDOCUMENT_VALIDATE_SUCCESS",
    ACTION_QUILLDOCUMENT_VALIDATE_FAILURE = "ACTION_QUILLDOCUMENT_VALIDATE_FAILURE",

    ACTION_QUILLDOCUMENT_CLEAR = "ACTION_QUILLDOCUMENT_CLEAR",

    ACTION_QUILLDOCUMENT_FILTER = "ACTION_QUILLDOCUMENT_FILTER";

export interface IQuillDocumentLoadSuccessAction {
    type: "ACTION_QUILLDOCUMENT_LOAD_SUCCESS";
    formData: Dtos.QuillDocument | Dtos.QuillDocument[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentLoadSuccessActionCreator {
    (
        formData: Dtos.QuillDocument | Dtos.QuillDocument[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IQuillDocumentLoadSuccessAction;
}

export interface IQuillDocumentLoadFailureAction {
    type: "ACTION_QUILLDOCUMENT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentLoadFailureAction;
}

export interface IQuillDocumentsSearchSuccessAction {
    type: "ACTION_QUILLDOCUMENT_SEARCH_SUCCESS";
    searchResult: Dtos.QuillDocument[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentsSearchSuccessActionCreator {
    (
        searchResult: Dtos.QuillDocument[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IQuillDocumentsSearchSuccessAction;
}

export interface IQuillDocumentsSearchFailureAction {
    type: "ACTION_QUILLDOCUMENT_SEARCH_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentsSearchFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentsSearchFailureAction;
}

export interface IQuillDocumentLoadByIdAction {
    type: "ACTION_QUILLDOCUMENT_LOAD_BY_ID";
    id: number;
}

export interface IQuillDocumentLoadByIdActionCreator {
    (id: number): IQuillDocumentLoadByIdAction;
}

export interface IQuillDocumentLoadByTypeAndPageAction {
    type: "ACTION_QUILLDOCUMENT_LOAD_BY_TYPE_AND_PAGE";
    quillDocumentType: Dtos.QuillDocumentType;
    page: Dtos.Page;
}

export interface IQuillDocumentLoadByTypeAndPageActionCreator {
    (
        quillDocumentType: Dtos.QuillDocumentType, 
        page: Dtos.Page
    ): IQuillDocumentLoadByTypeAndPageAction;
}

export interface IQuillDocumentsSearchAction {
    type: "ACTION_QUILLDOCUMENT_SEARCH";
    search: string;
}

export interface IQuillDocumentsSearchActionCreator {
    (search: string): IQuillDocumentsSearchAction;
}

export interface IQuillDocumentSaveAction {
    type: "ACTION_QUILLDOCUMENT_SAVE";
    formData: Dtos.QuillDocument;

}

export interface IQuillDocumentSaveActionCreator {
    (
        formData: Dtos.QuillDocument
    ): IQuillDocumentSaveAction;
}

export interface IQuillDocumentSaveSuccessAction {
    type: "ACTION_QUILLDOCUMENT_SAVE_SUCCESS";
    formData: Dtos.QuillDocument;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentSaveSuccessActionCreator {
    (
        formData: Dtos.QuillDocument,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IQuillDocumentSaveSuccessAction;
}

export interface IQuillDocumentSaveFailureAction {
    type: "ACTION_QUILLDOCUMENT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IQuillDocumentSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentSaveFailureAction;
}

export interface IQuillDocumentCreateAction {
    type: "ACTION_QUILLDOCUMENT_CREATE";
    quillDocumentType: Dtos.QuillDocumentType;
        page: Dtos.Page;
}

export interface IQuillDocumentCreateActionCreator {
    (
        quillDocumentType: Dtos.QuillDocumentType, 
        page: Dtos.Page
    ): IQuillDocumentCreateAction
}

export interface IQuillDocumentCreateSuccessAction {
    type: "ACTION_QUILLDOCUMENT_CREATE_SUCCESS";
    formData: Dtos.QuillDocument;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IQuillDocumentCreateSuccessActionCreator {
    (
        formData: Dtos.QuillDocument,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IQuillDocumentCreateSuccessAction;
}

export interface IQuillDocumentCreateFailureAction {
    type: "ACTION_QUILLDOCUMENT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IQuillDocumentCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentCreateFailureAction;
}

export interface IQuillDocumentValidateAction {
    type: "ACTION_QUILLDOCUMENT_VALIDATE";
    formData: Dtos.QuillDocument;

}

export interface IQuillDocumentValidateActionCreator {
    (
        formData: Dtos.QuillDocument
    ): IQuillDocumentValidateAction;
}

export interface IQuillDocumentValidateSuccessAction {
    type: "ACTION_QUILLDOCUMENT_VALIDATE_SUCCESS";
    formData: Dtos.QuillDocument;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IQuillDocumentValidateSuccessActionCreator {
    (
        formData: Dtos.QuillDocument,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IQuillDocumentValidateSuccessAction;
}

export interface IQuillDocumentValidateFailureAction {
    type: "ACTION_QUILLDOCUMENT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IQuillDocumentValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IQuillDocumentValidateFailureAction;
}

export interface IQuillDocumentClearAction {
    type: "ACTION_QUILLDOCUMENT_CLEAR";
    propertiesToClear?: string[];
}

export interface IQuillDocumentClearActionCreator {
    (propertiesToClear?: string[]): IQuillDocumentClearAction;
}

export interface IQuillDocumentFilterActionCreator {
    (formFilter: IFormFilter): IQuillDocumentFilterAction;
}

export interface IQuillDocumentFilterAction {
    type: "ACTION_QUILLDOCUMENT_FILTER";
    formFilter: IFormFilter;
}

export type QuillDocumentAction =
    IQuillDocumentLoadByIdAction |
    IQuillDocumentLoadByTypeAndPageAction |
    IQuillDocumentsSearchAction |
    IQuillDocumentLoadFailureAction |
    IQuillDocumentLoadSuccessAction |
    IQuillDocumentsSearchFailureAction |
    IQuillDocumentsSearchSuccessAction |
    IQuillDocumentSaveAction |
    IQuillDocumentSaveSuccessAction |
    IQuillDocumentSaveFailureAction |
    IQuillDocumentCreateAction |
    IQuillDocumentCreateSuccessAction |
    IQuillDocumentCreateFailureAction |
    IQuillDocumentValidateAction |
    IQuillDocumentValidateSuccessAction |
    IQuillDocumentValidateFailureAction |
    IQuillDocumentClearAction |
    IQuillDocumentFilterAction;
